const LAPYME_WHATSAPP_NUMBER = "5493515381175";
export const LAPYME_WHATSAPP = {
    formPlaceholder: "351 5381175",
    url: `https://wa.me/${LAPYME_WHATSAPP_NUMBER}`,
};
export function parsePhoneNumber(phone) {
    if (!phone) {
        return "";
    }
    let cleaned = phone.replace(/[^\d+]/g, "");
    if (!cleaned || cleaned === "+") {
        return "";
    }
    if (cleaned.startsWith("+54")) {
        let number = cleaned.slice(3);
        if (number.startsWith("9")) {
            number = number.slice(1);
        }
        if (number.startsWith("0")) {
            number = number.slice(1);
        }
        if (number.length >= 8 && number.length <= 10) {
            return `+54${number}`;
        }
        if (number.length > 10) {
            return `+54${number.slice(0, 10)}`;
        }
        return `+54${number}`;
    }
    if (cleaned.startsWith("54") && cleaned.length >= 10) {
        let number = cleaned.slice(2);
        if (number.startsWith("9")) {
            number = number.slice(1);
        }
        if (number.startsWith("0")) {
            number = number.slice(1);
        }
        if (number.length >= 8 && number.length <= 10) {
            return `+54${number}`;
        }
        if (number.length > 10) {
            return `+54${number.slice(0, 10)}`;
        }
    }
    if (cleaned.startsWith("+")) {
        cleaned = cleaned.slice(1);
    }
    let localNumber = cleaned;
    if (localNumber.startsWith("0")) {
        localNumber = localNumber.slice(1);
        if (localNumber.startsWith("0")) {
            localNumber = localNumber.slice(1);
        }
    }
    if (localNumber.startsWith("15") && localNumber.length > 10) {
        localNumber = localNumber.slice(2);
    }
    if (localNumber.length === 8) {
        return localNumber;
    }
    if (localNumber.length === 10) {
        return localNumber;
    }
    if (localNumber.length > 10) {
        return localNumber.slice(0, 10);
    }
    return localNumber;
}
